import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { MultiSelectTagWithoutOptionsFragmentDoc } from './MultiSelectTagWithoutOptions';
import { SharedByWorkspaceFragmentDoc } from '../../../../../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
import { IntegrationProviderLiteFragmentDoc } from '../../../../../../integrations/graphql/fragments/generated/IntegrationProviderLite';
import { TagControlConfigFragmentDoc } from './TagControlConfig';
export type MultiSelectTagTaskDetailsFragment = { id: string, name: string, description?: string | null, availableOn: Array<Types.TagAvailableOnEnum>, type: Types.TagTypeEnum, subWorkspaces?: Array<string> | null, category?: Types.TagCategoryEnum | null, source?: string | null, subType?: Types.TagSubTypeEnum | null, integrationProvider?: { id: string, name: string, provider: Types.IntegrationProviderEnum } | null, settings: { availableInLibrary: boolean, requiredTag: boolean, controlConfig?: { controls: Array<{ controllingEntity: { type: Types.TagControlSourcePropertyTypeEnum, value: string }, rules: Array<{ source: { operator: Types.TagControlOperatorEnum, values: Array<string> }, target: { operator: Types.TagControlOperatorEnum, values: Array<string> } }> }> } | null, iconSettings: { type: Types.IconTypeEnum, value: string } }, createdBy?: { id: string, name?: string | null } | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null };


export type MultiSelectTagTaskDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const MultiSelectTagTaskDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment MultiSelectTagTaskDetails on MultiSelectTagType {
  ...MultiSelectTagWithoutOptions
  integrationProvider {
    ...IntegrationProviderLite
  }
  settings {
    controlConfig {
      ...TagControlConfig
    }
  }
}
    `;